import { stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField(),
  label: stringField(),
  description: stringField()
};
